/**
 * This component is a fork of react-phone-number.
 * `react-phone-number` uses a google library for formatting which has been removed from this fork.
 * This component uses a `formator` prop which does the formatting.
 *
 * 
 * Phone component used to get the user's phone number
 * - utilizes Google's libphonenumber for phone formatting (https://github.com/seegno/google-libphonenumber)
 * - used with account creation and can be a hidden input
 */

import PropTypes from 'prop-types';

import React from 'react';
import { TextInput } from '@paypalcorp/pp-react';

class PhoneNumber extends React.Component {
	static propTypes = {
		type: PropTypes.string.isRequired,
		label: PropTypes.string.isRequired,
		exampleNumber: PropTypes.string.isRequired,
		phoneCode: PropTypes.string,
		formator: PropTypes.func,
		country: PropTypes.string.isRequired,
		pattern: PropTypes.string,
		maxlength: PropTypes.number,
		required: PropTypes.bool,
		value: PropTypes.string,
		changePhone: PropTypes.func.isRequired,
		errorMessage: PropTypes.string,
		handleBlur: PropTypes.func,
	};

	static defaultProps = {
		type: 'tel',
		handleBlur: () => {}
	};

	state = {
		showIsRequiredError: false
	};

	/**
	* Get the formatted phone number using Google's libphonenumber
	* libphonenumber throws an error if the number provided is only 1 character long
	* @param {String} phone - the phone number
	* @return {String} phone - the formatted phone number
	*/
	getFormattedPhoneNumber = (phone = '') => {
		let { phoneCode } = this.props;

		let phoneNumber = phone;

		if (this.props.formator) {
			phoneNumber = this.props.formator(phoneCode, phoneNumber);
		}

		return phoneNumber;

	};

	/**
	* Check for a phoneNumber value
	* If the field is required, we should show that this field needs a value
	* @param {String} phoneNumber - the card number
	*/
	handleCheckForValue = (phoneNumber) => {
		const isRequired = this.props.required;
		this.setState({ showIsRequiredError: isRequired && !phoneNumber });
	};

	/**
	* Handle changing the phone number
	* Remove non-digits from the phone and pass it to Griffin to format it
	* @param {String} phone - the phone number
	* @return {String} phone - the formatted phone number
	*/
	handleChangePhone = (phone, mssg_error) => {
		phone = phone.replace(/\D/g, ''); // remove non-digits for when the griffin formatting kicks in
		this.handleCheckForValue(phone);
		this.props.changePhone(phone, mssg_error);
		return this.getFormattedPhoneNumber(phone);
	};

	/**
	* Check for a security code value and call parent's handleBlur
	* @param {String} phoneNumber - the card number
	*/
	handleBlur = (phoneNumber) => {
		phoneNumber = phoneNumber.replace(/\D/g, '');
		this.handleCheckForValue(phoneNumber);
		this.props.handleBlur(phoneNumber, this.props.phoneCode);
	};

	render() {
		let initialValue = this.getFormattedPhoneNumber(this.props.value);
		let { errorMessage } = this.props;

		return (
            <div style={{ margin: '0 0 10px', position: 'relative' }}>
				{
					this.props.type !== 'hidden' &&
					<TextInput
						type={this.props.type}
						name="phone"
						id="phone"
						label={this.props.label}
						placeholder={this.props.exampleNumber}
						pattern={this.props.pattern}
						required={this.props.required}
						value={initialValue}
						onBlur={(event) => this.handleBlur(event.target.value)}
						onChange={(event) => this.handleChangePhone(event.target.value, 'errMessagePhoneNumber')}
						errorText={errorMessage}
					/>
				}
			</div>
		);
	}
}

export default PhoneNumber;